// extracted by mini-css-extract-plugin
module.exports = {"root":"login_root__2jUum","main":"login_main__3RDfQ","title":"login_title__3PXjU","subtitle":"login_subtitle__27QhP","submit":"login_submit__2EGhE"};